// extracted by mini-css-extract-plugin
export default {"ContactNumberInput":"ContactNumberInput_ContactNumberInput__YYRCD","Label":"ContactNumberInput_Label__4Z00m"};